//BOS User
export const SET_BOSUSER = "SET_BOSUSER";
export const CLEAR_BOSUSER = "CLEAR_BOSUSER";

//Solutions Cache
export const SET_SOLUTIONSCACHE = "SET_SOLUTIONSCACHE";
export const CLEAR_SOLUTIONSCACHE = "CLEAR_SOLUTIONSCACHE";

//DataSegments
export const SET_CONFIGDATASEGMENT = "SET_CONFIGDATASEGMENT";
export const CLEAR_CONFIGDATASEGMENT = "CLEAR_CONFIGDATASEGMENT";
export const SET_DATASEGMENT = "SET_DATASEGMENT";
export const UPDATE_DATASEGMENT = "UPDATE_DATASEGMENT";
export const CLEAR_DATASEGMENT = "CLEAR_OPENDATASEGMENT";

//AppState
export const SET_SHOW_APPTITLE = "SET_SHOW_APPTITLE";
export const SET_SHOW_MAINTASKS = "SET_SHOW_MAINTASKS";
export const SET_SHOW_SIDEBAR = "SET_SHOW_SIDEBAR";
export const SET_DISABLE_LAUNCHPAD = "SET_DISABLE_LAUNCHPAD";
export const SET_BOSSERVER_UNAVAILABLE = "SET_BOSSERVER_UNAVAILABLE";
export const SET_APPLICATION_IDLE = "SET_APPLICATION_IDLE";
export const SET_UILANGUAGE = "SET_UILANGUAGE";
export const SET_DATAVIEWLANGUAGE = "SET_DATAVIEWLANGUAGE";

//AppSettings
export const SET_THEME = "SET_THEME";
export const SET_TASKLAYOUT = "SET_TASKLAYOUT";

//Sessions
export const SET_CURRENT_SESSION = "SET_CURRENT_SESSION";
export const ADD_SESSION = "ADD_SESSION";
export const UPDATE_SESSION = "UPDATE_SESSION";
export const UPDATE_SESSION_VIEWPORTS = "UPDATE_SESSION_VIEWPORTS";
export const REMOVE_SESSION = "REMOVE_SESSION";
export const CLEAR_SESSIONS = "CLEAR_SESSIONS";

